module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/upload/upload.component.css
// module id = ./src/app/upload/upload.component.css
// module chunks = main